/** Shortcodes players can type inline — converted on send. */
const EMOJI_CODES: Record<string, string> = {
  ":)": "😊", ":(": "😢", ":D": "😄", ";)": "😉", ":P": "😛",
  "<3": "❤️", ":o": "😮", ":/": "😕", "xD": "😆", ":*": "😘",
  ":wave:": "👋", ":heart:": "❤️", ":fire:": "🔥", ":star:": "⭐",
  ":laugh:": "😂", ":cry:": "😭", ":think:": "🤔", ":cool:": "😎",
  ":angry:": "😠", ":sleep:": "😴", ":party:": "🎉", ":thumbsup:": "👍",
  ":thumbsdown:": "👎", ":clap:": "👏", ":eyes:": "👀", ":sparkles:": "✨",
  ":sword:": "⚔️", ":shield:": "🛡️", ":skull:": "💀", ":gem:": "💎",
  ":music:": "🎵", ":moon:": "🌙", ":sun:": "☀️", ":tree:": "🌳",
  ":ghost:": "👻", ":dragon:": "🐉", ":crown:": "👑", ":potion:": "🧪",
  ":bow:": "🏹", ":castle:": "🏰", ":wizard:": "🧙", ":fairy:": "🧚",
};

/** Grid of emoji shown in the picker (subset for quick access). */
const PICKER_EMOJI = [
  "👋", "😊", "😄", "😂", "😎", "🤔", "😢", "😠",
  "❤️", "🔥", "⭐", "✨", "🎉", "👍", "👏", "👀",
  "⚔️", "🛡️", "💀", "💎", "🐉", "👑", "🧪", "🏹",
  "🏰", "🧙", "🧚", "🌙", "☀️", "🌳", "🎵", "👻",
];

import { playChatToggle, playChatSend, playEmojiPicker } from "@/audio/SoundManager";

function replaceShortcodes(text: string): string {
  let result = text;
  for (const [code, emoji] of Object.entries(EMOJI_CODES)) {
    // Use split+join for simple literal replacement (no regex escaping needed)
    result = result.split(code).join(emoji);
  }
  return result;
}

export class ChatInput {
  private bar = document.getElementById("chat-bar")!;
  private input = document.getElementById("chat-input") as HTMLInputElement;
  private hint = document.getElementById("chat-hint")!;
  private emojiBtn = document.getElementById("emoji-btn")!;
  private emojiPicker = document.getElementById("emoji-picker")!;
  private _active = false;
  private onSend: ((text: string) => void) | null = null;

  constructor() {
    window.addEventListener("keydown", (e) => this.handleKey(e));
    this.input.addEventListener("keydown", (e) => {
      if (e.key === "Enter") {
        this.submit();
        e.preventDefault();
      } else if (e.key === "Escape") {
        this.close();
        e.preventDefault();
      }
      // Stop all keys from reaching Phaser/MoveController while typing
      e.stopPropagation();
    });

    this.emojiBtn.addEventListener("click", () => this.togglePicker());
    this.buildPicker();
  }

  get active(): boolean {
    return this._active;
  }

  setSendHandler(fn: (text: string) => void): void {
    this.onSend = fn;
  }

  private handleKey(e: KeyboardEvent): void {
    if (e.key === "Enter") {
      if (this._active) {
        this.submit();
      } else {
        this.open();
      }
      e.preventDefault();
    } else if (e.key === "Escape" && this._active) {
      this.close();
      e.preventDefault();
    }
  }

  private open(): void {
    this._active = true;
    this.bar.classList.add("open");
    this.hint.style.display = "none";
    this.input.value = "";
    this.input.focus();
    playChatToggle();
  }

  private close(): void {
    this._active = false;
    this.bar.classList.remove("open");
    this.emojiPicker.classList.remove("open");
    this.hint.style.display = "";
    this.input.blur();
    playChatToggle();
  }

  private submit(): void {
    const raw = this.input.value.trim();
    if (raw.length > 0 && this.onSend) {
      this.onSend(replaceShortcodes(raw));
      playChatSend();
    }
    this.close();
  }

  private togglePicker(): void {
    this.emojiPicker.classList.toggle("open");
    this.input.focus();
    playEmojiPicker();
  }

  private buildPicker(): void {
    for (const emoji of PICKER_EMOJI) {
      const btn = document.createElement("button");
      btn.type = "button";
      btn.textContent = emoji;
      btn.addEventListener("click", () => {
        this.input.value += emoji;
        this.emojiPicker.classList.remove("open");
        this.input.focus();
      });
      this.emojiPicker.appendChild(btn);
    }
  }
}
